import { Injectable } from '@angular/core';
import { Position } from '@capacitor/geolocation';
import { TemplateField } from '@core/definitions/template.defitions';
import { Driver } from '@core/models/Driver';
import { Unit } from '@core/models/Unit';
import { ApiGatewayRoutesService } from '@core/services/api.gateway-routes.service';
import { BaseEntitiesService } from '@core/services/entities-services/base-entities.service';
import { SessionService } from '@core/services/session.service';
import { ToastController } from '@ionic/angular';
import { lastValueFrom } from 'rxjs';
import { Task } from '../../../routes/models/Task';
@Injectable({ providedIn: 'root' })
export class TasksService extends BaseEntitiesService<Task> {
  constructor(private _apiRoutes: ApiGatewayRoutesService, override _toast: ToastController, override _session: SessionService) {
    super(_apiRoutes, _toast, _session);
  }
  public async signAttachment(taskId: string, routeId: string, attachmentId: string, image: string, position: Position, customFields: TemplateField[] = [], unit: Unit, driver: Driver): Promise<Task | null> {
    try {
      return await lastValueFrom<Task>(this._apiRoutes.put(`/v2/tasks/attachment/sign`, {
        taskId,
        routeId,
        attachmentId,
        image,
        location: { lat: position.coords.latitude, lon: position.coords.longitude, address: '', isGeofence: false },
        customFields,
        unit: unit,
        driver: driver,
      }, false));
    } catch (e: any) {
      const toast = await this._toast.create({ color: 'danger', message: `Error al firmar el adjunto: ${e.message}` });
      await toast.present();
      return null;
    }
  }
  // Selected element
  public selectElement(element: Task): void {
    this._selected.next(element);
  }
  public getSelectedElement(): Task {
    return this._selected.getValue();
  }
  // Repository
  add(element: Task[] | Task): Promise<Task> {
    throw new Error('Not implemented');
  }
  remove(elements: Task[]): Promise<void> {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await lastValueFrom(this._apiRoutes.post('/v2/tasks/delete', { ids: elements.map(task => task.id) }));
        return resolve(response);
      } catch (e) {
        console.log(e);
        return reject(e);
      }
    });
  }
  update(element: Task): Promise<Task> {
    return new Promise<Task>(async (resolve, reject) => {
      try {
        const session = this._session.getSession();
        const driver = session.driver;
        element.realInterval.resource = { type: 'driver', id: driver.id, name: driver.name };
        const response = await lastValueFrom(this._apiRoutes.put(`/tasks`, element));
        return resolve(response);
      } catch (e) {
        console.log(e);
        return reject(e);
      }
    });
  }
}
